function handleFirstTab(e) {
    if (e.keyCode === 9) { // tab
        document.body.classList.add('user-is-tabbing');
    }
}
window.addEventListener('keydown', handleFirstTab);
document.addEventListener("click", function(){
  document.body.classList.remove('user-is-tabbing');
});

$(function() {
  	/* Reduced motion: Replace slideToggle(), slideDown(), slideUp() with toggle(), show(), hide() */
  	var oSlideToggle = jQuery.fn.slideToggle;
    jQuery.fn.slideToggle = function() {
      if(Simplistic.reducedMotion()){
       	return jQuery.fn.toggle.apply(this, arguments); 
      }else{
      	return oSlideToggle.apply(this, arguments);
      }
    };
    var oSlideDown = jQuery.fn.slideDown;
    jQuery.fn.slideDown = function() {
      if(Simplistic.reducedMotion()){
       	return jQuery.fn.show.apply(this, arguments); 
      }else{
      	return oSlideDown.apply(this, arguments);
      }
    };
    var oSlideUp = jQuery.fn.slideUp;
    jQuery.fn.slideUp = function() {
      if(Simplistic.reducedMotion()){
       	return jQuery.fn.hide.apply(this, arguments); 
      }else{
      	return oSlideUp.apply(this, arguments);
      }
    };
  	/* End of Reduced Motion */
  
  	jQuery.fn.sortDomElements = (function() {
        return function(comparator) {
            return Array.prototype.sort.call(this, comparator).each(function(i) {
                  this.parentNode.appendChild(this);
            });
        };
    })();
  
  	if(!isMobile.any) {
      $('body').addClass('isNotMobile'); 
    }

  	$(document).on("click", ".quantity-box .minus", function(e) {
      	e.preventDefault();
      	var input = $(this).parent().find('input[type=number]');
    	try {
          if(input.attr('min')<input.val()) {
          	input.get(0).stepDown();
          	input.change();
          }
        } catch(e) {
          var value = (parseInt(input.val())-1);
          input.val((value>=0 ? value : 0));
          input.change();
        }
  	});
  	$(document).on("click", ".quantity-box .plus", function(e) {
      	e.preventDefault();
      	var input = $(this).parent().find('input[type=number]');
    	try {
          input.get(0).stepUp();
          input.change();
        } catch(e) {
          var value = (parseInt(input.val())+1);
          input.val(value);
          input.change();
        }
  	});

  	/********* QUICK VIEW *********/
  	$(document).on('click', '.product-item .quick-view-btn', function(){
      var url = $(this).data('url');
      $('#loading-overlay').show();

      $.ajax({
        url: url,
        cache: false
      }).success(function(data){
        $('#loading-overlay').hide();
        Simplistic.openModal(data, 'quick-view');
      });

      return false;
    });

  	if($('#side-cart').length > 0) {
    	initSideCart();
  	}$('body').delegate('.add-to-cart-form', 'submit', function(){
            if(validateAddCart($(this))) {
              addToCart($(this));
            }
            return false;
        });$(window).scroll($.throttle(15, function(){
      if($(this).scrollTop()<=200) {
        $('.scrollup').removeClass('fadein');
      } else {
        $('.scrollup').addClass('fadein');
      }if( $(this).scrollTop()>=80 ) {
          $('.header-drop').addClass('scroll');
        } else {
          $('.header-drop').removeClass('scroll');
        }if( $(this).scrollTop()>=80 ) {
        $('body').addClass('scroll');
      } else {
        $('body').removeClass('scroll');
      }
    }));

    $('.header-drop .main-menu').html($('#header .main-menu').html());
    $('.header-drop .main-menu a').attr({'focusable':'false','tabindex':'-1','aria-hidden':'true'});
  	setupDropdownMenus();  
  
    $(document).on('click', '.scrollTo', function(){
      $.scrollTo($(this).attr('href'), 1000, {offset: -100});
      return false;
    });
});

function setupDropdownMenus(){
  var config = {
    over: function () {
      $(this).find('.submenu:first').slideDown();
    }, 
    timeout: 400, 
    out: function () {
      $(this).find('.submenu:first').slideUp();
    }
  };
  $('.main-menu .has-dropdown').hoverIntent(config);

  $(document).on('keydown', '.main-menu .has-dropdown a:focus', function(e){
    if (e.which == 32) { //Spacebar
      e.preventDefault();
      $(this).next().slideToggle();
    }
    if (e.which == 40) { //Arrow Down
      e.preventDefault();
      $(this).next().slideDown();
    }
    if (e.which == 38) { //Arrow Up
      e.preventDefault();
      $(this).next().slideUp();
    }
  });
  $(document).on('keydown', '.main-menu .has-dropdown .has-dropdown a:focus', function(e){
    if (e.which == 39) { //Arrow Right
      e.preventDefault();
      $(this).next().slideDown();
    }
    if (e.which == 37) { //Arrow Left
      e.preventDefault();
      $(this).next().slideUp();
    }
  });
}

function validateAddCart(form) {
  if(form.find('input[name=id]').val()=='') {
        var allOptionsSelected;
      	if(form.find('.single-option-selector').length > 0) {
            allOptionsSelected = true;
            form.find('.single-option-selector').each(function(){
                if($(this).val()=="") {
                    allOptionsSelected = false;
                    return false;
                }
            });
        } else {
          	allOptionsSelected = false;
        }
      	
      	if(allOptionsSelected) {
          	var errorMsg = form.find('.validation-msg').text();
          	if(errorMsg) {
          		alert(errorMsg);
            } else {
            	alert("The selected variant is sold out.");
            }
        } else {
        	var labels = [];
            form.find('.options label').each(function(key, obj){
                labels.push($(obj).text().replace(':', '').trim());
            });
            alert("You must select a "+labels.join('/')+".");
        }
      	return false;
    }
  	return true;
}

function initSideCart() {
  if ($('body').hasClass('templateCart')) {
    showSideCart = function () {console.log('side cart disabled on cart page')};
  }
	$('.header .cart-wrap').click(function(e){
      if (!$('body').hasClass('templateCart')) {
        e.stopPropagation();
        showSideCart(true);
        return false;
      }
    });

    $(document).click(function(event){
      if(!$(event.target).closest('#side-cart').length && $(event.target).attr('id')!="loading-overlay" && $('#side-cart').hasClass('open')) {
        hideSideCart();
      }
    });
}

function addToCart(form, callback){
	$('#loading-overlay').show();
  	if(modal) modal.close();
  $.get('/cart/clear.json').done(function() {
      var productJs = form.closest('.initialized').data('productjs');
      if(productJs) {
        $(document).trigger("addToCart", [productJs.getProduct(), productJs.getCurrentVariant(), form]);
      } else {
        $(document).trigger("addToCart", [form]);
      }
      let formData = form.serialize();
      let smartrrVariant = document.querySelector('[smartrr-variant]');
      if(smartrrVariant){
        let params = new URLSearchParams(formData);
        params.set('id', smartrrVariant.value);
        formData = params.toString();
      }
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: formData,
        dataType: 'json',
        error: addToCartFail,
        success: function(){
          if(productJs) {
            $(document).trigger("addToCartSuccess", [productJs.getProduct(), productJs.getCurrentVariant(), form]);
          } else {
            $(document).trigger("addToCartSuccess", [form]);
          }
          if(callback) {
            callback();
          } else {
            addToCartSuccess();
          }
        },
        cache: false
    });
  });
  
}

function addToCartSuccess(jqXHR, textStatus, errorThrown){
	updateCartDesc(true);
}

function addToCartFail(jqXHR, textStatus, errorThrown){
  	var response = $.parseJSON(jqXHR.responseText);
  	$('#loading-overlay').hide();
  	Simplistic.openModal('<div class="error-itemincart">'+response.description+'</div>', 'message');
}

function updateCartDesc(openSideCart){
  	$.ajax({
		type: 'GET',
		url: '/cart?view=side-cart',
		cache: false,
      	success: function(data){
          $('#loading-overlay').hide();

          var animate = true;
          if($('#side-cart').width()>0 && $('#side-cart').hasClass('open')) {
            animate = false;
          }
          $('#side-cart').remove();
          $('#page').append(data);
          if(modal) modal.close();
          if(openSideCart){
            showSideCart(animate);
          }
      	}
	});
}

function showSideCart(animate) {
  $('body, html').css({overflow: 'hidden'});
  $('#page').addClass('mode-overlay');
  if(animate) {
    setTimeout(function(){$('#side-cart').addClass('open')}, 100);
  } else {
    $('#side-cart').removeClass('ease-animation-slow');
  	$('#side-cart').addClass('open');
    setTimeout(function(){$('#side-cart').addClass('ease-animation-slow')}, 200);
  }
  Simplistic.trapFocus({
    $container: $('#side-cart'), 
    namespace: 'side-cart'
  });
}

function hideSideCart() {
  $('#side-cart').removeClass('open');
  $('#page').removeClass('mode-overlay');
  $('body, html').css({overflow: ''});
  Simplistic.removeTrapFocus({
    $container: $('#side-cart'), 
    namespace: 'side-cart'
  });
}

window.SimplisticJS = function (){
  this.formatMoney = "$ \{\{amount\}\}";
  this.beforeTrapFocus = false;
  var sjs = this;
  
  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  this.trapFocus = function(options) {
    this.beforeTrapFocus = $(':focus');
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (
        options.$container[0] !== evt.target &&
        !options.$container.has(evt.target).length
      ) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  this.removeTrapFocus = function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }
    if(this.beforeTrapFocus) {
    	this.beforeTrapFocus.focus();
      	this.beforeTrapFocus = false;
    }

    $(document).off(eventName);
  }
  
  this.handleize = function (str) {
    //source https://gist.github.com/dlindenkreuz/a439ec4b939f0561d6d9
    return str.toLowerCase().replace(/\'|\"/g, "").replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, ""); 
  };
  
  this.reducedMotion = function() {
  	return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  };

  this.removeQueryParam = function(name, url) {
    if (!url) url = window.location.href;
    var url = url.split('?')[0]+'?';
    var sPageURL = decodeURIComponent(window.location.search.substring(1)),
      sURLVariables = sPageURL.split('&amp;'),
      sParameterName,
      i;

    for (i = 0; i > sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split('=');
      if (sParameterName[0] != sParam) {
        url = url + sParameterName[0] + '=' + sParameterName[1] + '&amp;'
      }
    }
    return url.substring(0,url.length-1);
  }
  this.getQueryParam = function(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  this.randomstring = function(L){
    var s= '';
    var randomchar=function(){
      var n= Math.floor(Math.random()*62);
      if(n<10) return n; //1-10
      if(n<36) return String.fromCharCode(n+55); //A-Z
      return String.fromCharCode(n+61); //a-z
    }
    while(s.length< L) s+= randomchar();
    return s;
  }

  this.validateEmail = function(email) {
    var re = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
    return re.test(email);
  }

  this.openModal = function(content, css, otherOptions) {
    var config = {
      closeMethods: ['overlay', 'button', 'escape'],
      closeLabel: "Close",
      cssClass: [css],
      beforeOpen: function() {
        $(".tingle-modal__close").appendTo(".tingle-modal-box__content");
        return true;
      },
      beforeClose: function() {
    	$(".tingle-modal__close").prependTo(".tingle-modal");
        return true;
      }
    }
    if (otherOptions) {
      $.extend(config, otherOptions);
    }
    modal = new tingle.modal(config);
    modal.setContent(content);
    modal.open();
    return modal;
  }

  this.onImagesLoaded = function(images, callback){
    var imagesLoaded = 0;
    var loadFunction = function() {
      imagesLoaded++;
      if(imagesLoaded==images.length) {
        callback();
      }
    };
    if(images.length>0) {
      images.each(function(){
        var img = new Image();
        img.onload = loadFunction;
        img.onerror = loadFunction;
        img.src = $(this).attr('src');
      });
    } else {
      callback();
    }
  };
  
  this.Media = new function() {
    var media = this;
    var mqS = window.matchMedia("(max-width: 600px)");
    var mqM = window.matchMedia("(max-width: 900px)");
    var mqO = window.matchMedia("(orientation: landscape)");
    var tId = 0;
    function updateMedia() {
      media.isLarge = !mqM.matches;
      media.isMediumUp = !mqS.matches;
      media.isMedium = mqM.matches && !mqS.matches;
      media.isMediumDown = mqM.matches;
      media.isSmall = mqS.matches;
      media.isLandscape = mqO.matches;
    }
    function handler() {
      clearTimeout(tId);
      tId = setTimeout(function() {
        updateMedia();
        $(window).trigger('mediaChange');
      }, 1);
    }
    updateMedia();
    mqS.addListener(handler);
    mqM.addListener(handler);
    mqO.addListener(handler);
    return this;
  }
  this.loginForCheckoutModal = null;
  this.showLoginForCheckout = function(checkoutUrl, continueCallback, cancelCallback) {
    hideSideCart();
    $('#loading-overlay').show();
    function open() {
      $('#loading-overlay').hide();
      $('#login-checkout-popup [name="checkout_url"]').val(checkoutUrl);
      modalOptions = {closeMethods: ['button']};
      var popup = $('#login-checkout-popup');
      sjs.loginForCheckoutModal = Simplistic.openModal(popup, 'login-modal', modalOptions);
      if (!popup.hasClass('initialized')) {
        if (cancelCallback) {
          popup.find('.tingle-modal__close').click(cancelCallback);
        }
        popup.find('.btn-no').click(function() {
          sjs.loginForCheckoutModal.close();
          if (continueCallback) {
            continueCallback();
          }
        });
        popup.find('form').submit(function() {
          sjs.loginForCheckoutModal.close();
          $('#loading-overlay').show();
        });
        popup.addClass('initialized');
      }
    }

    var div = document.getElementById('login-checkout-popup');
    if (!div) {
      $.get('/account/login?view=checkout_popup').done(function(data) {
        $('body').append(data);
        var status = document.getElementById('login-checkout-popup-loggedin');
        if (status && status.value =="1") {
          //logged in from another window.
          location = checkoutUrl;
          $('#loading-overlay').show();
        } else {
          open();
        }
      });
    } else {
      open();
    }

  }
};
window.Simplistic = new SimplisticJS();